var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Emitter = monaco.Emitter;
// --- GreyCat configuration and defaults ---------
var DEFAULT_SETTINGS = {
    lint: true,
    lintOptions: {
        strict: true,
    },
};
var LanguageServiceDefaultsImpl = /** @class */ (function () {
    function LanguageServiceDefaultsImpl(languageId, settings) {
        this._onDidChange = new Emitter();
        this._gcTypes = {};
        this._gcFunctions = [];
        this._languageId = languageId;
        this.setSettings(settings);
    }
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "onDidChange", {
        get: function () {
            return this._onDidChange.event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "languageId", {
        get: function () {
            return this._languageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "settings", {
        get: function () {
            return this._settings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "gcTypes", {
        get: function () {
            return this._gcTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageServiceDefaultsImpl.prototype, "gcFunctions", {
        get: function () {
            return this._gcFunctions;
        },
        enumerable: true,
        configurable: true
    });
    LanguageServiceDefaultsImpl.prototype.setSettings = function (options) {
        this._settings = __assign({}, DEFAULT_SETTINGS, options);
        this._onDidChange.fire(this);
    };
    LanguageServiceDefaultsImpl.prototype.addTypes = function (types) {
        var _this = this;
        this._gcTypes = __assign({}, this._gcTypes, types);
        this._onDidChange.fire(this);
        return {
            dispose: function () {
                _this._gcTypes = {};
                _this._onDidChange.fire(_this);
            },
        };
    };
    LanguageServiceDefaultsImpl.prototype.addFunctions = function (functions) {
        var _this = this;
        var _a;
        (_a = this._gcFunctions).push.apply(_a, functions);
        this._onDidChange.fire(this);
        return {
            dispose: function () {
                _this._gcFunctions.length = 0;
                _this._onDidChange.fire(_this);
            },
        };
    };
    LanguageServiceDefaultsImpl.prototype.triggerChange = function () {
        this._onDidChange.fire(this);
    };
    return LanguageServiceDefaultsImpl;
}());
export { LanguageServiceDefaultsImpl };
var defaults = new LanguageServiceDefaultsImpl('greycat', DEFAULT_SETTINGS);
// Export API
function createAPI() {
    return defaults;
}
export default (monaco.languages.greycat = createAPI());
// --- Registration to monaco editor ---
function getMode() {
    return monaco.Promise.wrap(import('./gcMode'));
}
monaco.languages.register({ id: 'greycat', extensions: ['gcl'] });
monaco.languages.onLanguage('greycat', function () {
    return getMode().then(function (m) { return m.setupMode(defaults); });
});
//# sourceMappingURL=monaco.contribution.js.map